module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/pages/logs/logs-root-page.component.html
// module id = ../../../../../src/app/pages/logs/logs-root-page.component.html
// module chunks = 0